// Phase G3 Stage 3: /parent/skill — SkillDetail.
// MA-17: added validateSearch so skillId flows from SkillTree link to the screen.
import { createFileRoute } from "@tanstack/react-router";
import { SkillDetail } from "@/screens/SkillDetail";

export const Route = createFileRoute("/parent/skill")({
  validateSearch: (search: Record<string, unknown>): { skillId?: string } => ({
    skillId:
      typeof search.skillId === "string" && search.skillId.length > 0
        ? search.skillId
        : undefined,
  }),
  component: SkillDetail,
});
